module.exports = __webpack_public_path__ + "static/media/no-messages.3675fd2f.svg";